"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invariant = exports.isFunction = void 0;

var isFunction = function isFunction(obj) {
  return !!(obj && obj.constructor && obj.call && obj.apply);
};

exports.isFunction = isFunction;

var invariant = function invariant(condition, errorString) {
  if (!condition) {
    throw new Error(errorString);
  }
};

exports.invariant = invariant;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/permission-components/static-1.43/js/util/utilityFunctions.js
// module id = 166
// module chunks = 209 210 211 212